import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  tableCellClasses,
} from "@mui/material";
import styled from "@emotion/styled";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import { EyeIcon, FontFamily, SearchIcon } from "assets";
import Colors from "assets/Style/Colors";
import { ErrorToaster } from "components/Toaster";
import { CircleLoading } from "components/Loaders";
import Pagination from "components/Pagination";
import moment from "moment";
import DatePicker from "components/DatePicker";
import { CommaSeparator, handleExportWithComponent } from "utils";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { PrimaryButton } from "components/Buttons";
import { PDFExport } from "@progress/kendo-react-pdf";
import InputField from "components/Input";
import ExportServices from "services/Export";

// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    padding: "5px !important",

    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
    "& svg": {
      width: "40px !important",
      height: "40px !important",
    },
  },
});

function ExportPaymentList() {
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const classes = useStyles();
  const contentRef = useRef(null);
  const dispatch = useDispatch();

  const tableHead = [
    "Date",
    "Receipt.No",
    "Customer",
    "C-ID",
    "Currency",
    "Amount",
    "Exchange Rate",
    "Amount AED",
    "User",
    "Vin",
    "Actions",
  ];

  const [loader, setLoader] = useState(false);

  // *For Payment List
  const [paymentList, setPaymentList] = useState();
  const [isSearching, setIsSearching] = useState(false);

  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [ExportDatas, setExportDatas] = useState();
  const [ExportData, setExportData] = useState();

  // *For Permissions
  const [permissions, setPermissions] = useState();
  const [searchTerm, setSearchTerm] = useState("");

  // *For Booking Customer
  const [bookingCustomers, setBookingCustomers] = useState([]);
  const [selectedBookingCustomer, setSelectedBookingCustomer] = useState(null);

  // *For Filters
  const [filteredPaymentList, setFilteredPaymentList] = useState({});

  const [filters, setFilters] = useState({});
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();

  // *For Handle Date
  const handleFromDate = (newDate) => {
    try {
      // eslint-disable-next-line eqeqeq
      if (newDate == "Invalid Date") {
        setFromDate("invalid");
        return;
      }
      setFromDate(new Date(newDate));
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleToDate = (newDate) => {
    try {
      // eslint-disable-next-line eqeqeq
      if (newDate == "Invalid Date") {
        setToDate("invalid");
        return;
      }
      setToDate(new Date(newDate));
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Booking Customer
  const getCustomers = async (search) => {
    try {
      let params = {
        page: 1,
        limit: 100,
        name: search,
      };
      const { data } = await ExportServices.getExportCustomers(params);
      const customerOptions = data?.customers?.rows || [];
      setBookingCustomers((prev) => [...prev, ...customerOptions]);
      // setCustomersOptions(data?.customers?.rows);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Payment List

  // const getExportVehicles = async (page, limit, filter) => {
  //     try {
  //       const Page = page || currentPage;
  //       const Limit = limit || pageLimit;
  //       const Filter = { ...filters, ...filter };

  //       setCurrentPage(Page);
  //       setPageLimit(Limit);
  //       setFilters(Filter);

  //       let params = {
  //         page: Page,
  //         limit: Limit,
  //         ...Filter,
  //       };

  //       const { data } = await ExportServices.getExportGroupPaymentsList(params);

  //       let formattedData = [];

  //       if (data?.funds?.rows) {
  //         data?.funds?.rows.forEach((vehicle) => {
  //           if (vehicle?.payments) {
  //             vehicle?.payments.forEach((payment) => {
  //               formattedData.push({
  //                 created_at: vehicle?.created_at,
  //                 payment_id: payment?.id,
  //                 ev_id: vehicle?.ev_id,
  //                 id: vehicle?.id,
  //                 total_amount: vehicle?.total_amount,
  //                 payment_medium: payment?.details?.[0]?.payment_medium?.toUpperCase() ?? "-",
  //                 created_by: payment?.creator?.name ?? "-",
  //                 vin: vehicle?.vehicle?.vin ?? "-",
  //                 lot_number: vehicle?.vehicle?.lot_number ?? "-",
  //                 customer_name: vehicle?.vehicle?.customer?.name ?? "-",
  //                 customer_ref_id: vehicle?.vehicle?.customer?.ref_id ?? "-",
  //                 vendor_paid: parseFloat(vehicle?.vehicle?.vendor_paid) || 0,
  //                 final_price: parseFloat(vehicle?.vehicle?.final_price) || 0,
  //                 payment_date: payment?.payment_date || vehicle?.created_at,
  //                 vehicle_status: vehicle?.vehicle?.vehStatus ?? "-",
  //                 title_status: vehicle?.vehicle?.title_status ?? "-",
  //                 attachment: vehicle?.vehicle?.attachment || null,
  //                 total_invoices: vehicle?.payments,
  //               });
  //             });
  //           }
  //         });
  //       }

  //       setExportDatas(formattedData);
  //       setTotalCount(data?.funds?.count);
  //     } catch (error) {
  //       ErrorToaster(error);
  //     }
  //   };

  const getExportVehicles = async (page, limit, filter) => {
    try {
      const Page = page || currentPage;
      const Limit = limit || pageLimit;
      const Filter = { ...filters, ...filter };

      setCurrentPage(Page);
      setPageLimit(Limit);
      setFilters(Filter);

      let params = {
        page: Page,
        limit: Limit,
        static_date: "2025-05-06",
        ...Filter,
      };

      const { data } = await ExportServices.getExportGroupPaymentsList(params);

      let formattedData = [];

      if (data?.funds?.rows?.length) {
        data.funds.rows.forEach((payment) => {
          if (payment?.vehicles?.length) {
            payment.vehicles.forEach((vehicle) => {
              formattedData.push({
                created_at: payment.payment_date,
                payment_detail_id: payment.payment_detail_id,
                ev_id: vehicle.ev_id,
                id: vehicle.ev_id,
                total_amount: parseFloat(payment.total_amount) || 0,
                payment_medium: payment?.payment_medium?.toUpperCase() ?? "-",
                created_by: payment?.creator?.name ?? "-",
                vin: vehicle?.vin ?? "-",
                lot_number: vehicle?.lot_number ?? "-",
                customer_name: vehicle?.customer?.name ?? "-",
                customer_ref_id: vehicle?.customer?.ref_id ?? "-",
                vendor_paid: parseFloat(vehicle?.vendor_paid) || 0,
                final_price: parseFloat(vehicle?.final_price) || 0,
                payment_date: payment?.payment_date ?? "-",
                vehicle_status: vehicle?.vehStatus ?? "-",
                title_status: vehicle?.title_status ?? "-",
                attachment: payment?.attachment || null,
                total_invoices: payment?.vehicles?.length ?? 1,
              });
            });
          }
        });
      }

      setExportDatas(formattedData);
      setExportData(data?.funds?.rows);
      setTotalCount(data?.funds?.count);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Handle Filter
  const handleFilter = async (data) => {
    setLoader(true);
    if (isSearching) return;

    setIsSearching(true);
    try {
      await getExportVehicles(1, "", data);
    } catch (err) {
      console.error("Search failed:", err);
    } finally {
      setIsSearching(false);
      setLoader(false);
    }
  };
  // *For Apply Filters
  const applyFilter = async () => {
    try {
      let data = {
        to_date: moment(toDate).format("YYYY-MM-DD"),
        from_date: moment(fromDate).format("YYYY-MM-DD"),
      };

      getExportVehicles(1, "", data);
    } catch (error) {
      ErrorToaster(error);
    }
  };
  const downloadExcel = async () => {
    const headers = tableHead.filter((item) => item !== "Actions");
    const rows = ExportData?.map((item) => [
      moment(item?.created_at).format("DD-MMM-YYYY"),
      String(`GVI-${item?.vehicles?.[0]?.ev_id}`),
      item?.vehicles?.[0]?.customer?.name || "-",
      item?.vehicles?.[0]?.customer?.ref_id || "-",
      item?.currency?.toUpperCase() || "-",
      parseFloat(item?.total_amount).toFixed(2) || "-",
      parseFloat(item?.ex_rate).toFixed(2) || "-",
      parseFloat(item?.total_amount * 3.675).toFixed(2) || "-",
      item?.creator?.name || "-",
      item?.vehicles?.[0]?.vin || "-",
    ]);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    worksheet.addRow(headers);
    rows.forEach((r) => worksheet.addRow(r));

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "data.xlsx");
  };

  useEffect(() => {
    getExportVehicles();
    getCustomers();
  }, []);

  return (
    <Box sx={{ m: 4, mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mr: 4,
          my: 4,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            color: Colors.charcoalGrey,
            fontFamily: FontFamily.NunitoRegular,
          }}
        >
          Export Payment Receipts
        </Typography>
        {ExportData?.length > 0 && (
          <Box
            sx={{
              textAlign: "right",
              p: 4,
              display: "flex",
              gap: 2,
            }}
          >
            <PrimaryButton
              title="Download PDF"
              type="button"
              style={{ backgroundColor: Colors.bluishCyan }}
              onClick={() => handleExportWithComponent(contentRef)}
            />
            <PrimaryButton
              title={"Download Excel"}
              onClick={() => downloadExcel()}
            />
          </Box>
        )}
      </Box>
      <Box
        component={"form"}
        onSubmit={handleSubmit(applyFilter)}
        sx={{
          m: "20px 0 20px 5px",
        }}
      >
        {/* Filters */}
        <Box
          sx={{
            boxShadow: " 0px 3px 10px 0px #00000040",
            p: 3,
            borderRadius: "15px",
          }}
        >
          <Grid container spacing={1}>
            <Grid item xs={12} sm={3}>
              <InputField
                size={"small"}
                label={"Search"}
                placeholder={"Search"}
                inputStyle={{ backgroundColor: "#f5f5f5" }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                register={register("search", {
                  onChange: (e) => handleFilter({ search: e.target.value }),
                })}
              />
            </Grid>
            {/* <Grid item xs={12} sm={2.5}>
              <SelectField
                size={'small'}
                onSearch={(v) => getCustomers(v)}
                label={'Customer'}
                options={bookingCustomers}
                selected={selectedBookingCustomer}
                onSelect={(value) => { setSelectedBookingCustomer(value); handleFilter({ customer_id: value?.id }) }}
                register={register("bookingCustomer")}
              />
            </Grid> */}
            <Grid item xs={10} sm={2.5}>
              <DatePicker
                disableFuture={true}
                size="small"
                label={"From Date"}
                value={fromDate}
                onChange={(date) => handleFromDate(date)}
              />
            </Grid>
            <Grid item xs={10} sm={2.5}>
              <DatePicker
                disabled={fromDate ? false : true}
                disableFuture={true}
                size="small"
                minDate={fromDate}
                label={"To Date"}
                value={toDate}
                onChange={(date) => handleToDate(date)}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Box
                sx={{
                  mt: "28px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <PrimaryButton type={"submit"} title={"Search"} />
              </Box>
            </Grid>
          </Grid>

          {ExportData ? (
            <Fragment>
              <PDFExport
                ref={contentRef}
                landscape={true}
                paperSize="A4"
                margin={5}
                fileName="Payment Receipts"
              >
                <Box className="pdf-show" sx={{ display: "none" }}>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        color: Colors.charcoalGrey,
                        fontFamily: FontFamily.NunitoRegular,
                        mb: 2,
                      }}
                    >
                      Payment Receipts
                    </Typography>
                    <Box
                      sx={{
                        fontWeight: 400,
                        fontSize: "12px",
                        mt: 1.5,
                        color: Colors.charcoalGrey,
                      }}
                    >
                      <span>Date: &nbsp;&nbsp;</span>
                      {moment().format("MM-DD-YYYY")}
                    </Box>
                  </Box>
                </Box>
                {/* ========== Table ========== */}
                <TableContainer
                  component={Paper}
                  sx={{
                    boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                    borderRadius: 2,
                    maxHeight: "calc(100vh - 330px)",
                  }}
                  className="table-box"
                >
                  <Table stickyHeader sx={{ minWidth: 500 }}>
                    <TableHead>
                      <TableRow>
                        {tableHead.map((item, index) => (
                          <Cell className="pdf-table" key={index}>
                            {item}
                          </Cell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {!loader ? (
                        ExportDatas?.length > 0 ? (
                          <Fragment>
                            {ExportData.map((item, index) => (
                              <Row
                                key={index}
                                sx={{ bgcolor: index % 2 !== 0 && "#EEFBEE" }}
                              >
                                <Cell className="pdf-table">
                                  {moment(item?.payment_date).format(
                                    "DD-MMM-YYYY",
                                  )}
                                </Cell>
                                <Cell className="pdf-table">
                                  GVI-{item?.vehicles?.[0]?.ev_id}
                                </Cell>
                                <Cell className="pdf-table">
                                  <Tooltip
                                    className="pdf-hide"
                                    title={
                                      item?.vehicles?.[0]?.customer?.name ?? "-"
                                    }
                                    arrow
                                    placement="top"
                                    slotProps={{
                                      popper: {
                                        modifiers: [
                                          {
                                            name: "offset",
                                            options: {
                                              offset: [10, -2],
                                            },
                                          },
                                        ],
                                      },
                                    }}
                                  >
                                    {item?.vehicles?.[0]?.customer?.name}
                                  </Tooltip>
                                  <Box
                                    component={"div"}
                                    className="pdf-show"
                                    sx={{ display: "none !important" }}
                                  >
                                    {item?.vehicles?.[0]?.customer?.name ?? "-"}
                                  </Box>
                                </Cell>
                                <Cell className="pdf-table">
                                  {item?.vehicles?.[0]?.customer?.ref_id ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {item?.currency?.toUpperCase() ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {CommaSeparator(
                                    parseFloat(item?.total_amount).toFixed(2),
                                  ) ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {parseFloat(item?.ex_rate).toFixed(3) ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {CommaSeparator(
                                    parseFloat(
                                      item?.total_amount * 3.675,
                                    ).toFixed(2),
                                  ) ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  <Tooltip
                                    className="pdf-hide"
                                    title={item?.user?.name ?? "-"}
                                    arrow
                                    placement="top"
                                    slotProps={{
                                      popper: {
                                        modifiers: [
                                          {
                                            name: "offset",
                                            options: {
                                              offset: [10, -2],
                                            },
                                          },
                                        ],
                                      },
                                    }}
                                  >
                                    {item?.creator?.name?.length > 8
                                      ? item?.creator?.name?.slice(0, 5) + "..."
                                      : item?.creator?.name}
                                  </Tooltip>
                                  <Box
                                    component={"div"}
                                    className="pdf-show"
                                    sx={{ display: "none !important" }}
                                  >
                                    {item?.creator?.name ?? "-"}
                                  </Box>
                                </Cell>
                                <Cell className="pdf-table">
                                  {item?.vehicles?.[0]?.vin}
                                </Cell>
                                <Cell className="pdf-table">
                                  <Box
                                    component={"div"}
                                    className="pdf-hide"
                                    sx={{ gap: "16px !important" }}
                                  >
                                    <Box
                                      onClick={() =>
                                        window.open(
                                          `/export-payments-recipt/${item?.payment_detail_id}`,
                                          "_blank",
                                          "noopener,noreferrer",
                                        )
                                      }
                                    >
                                      <IconButton
                                        sx={{
                                          bgcolor: Colors.primary,
                                          "&:hover": {
                                            bgcolor: Colors.primary,
                                          },
                                        }}
                                      >
                                        <EyeIcon />
                                      </IconButton>
                                      <Typography variant="body2">
                                        View Receipt
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Cell>
                              </Row>
                            ))}
                          </Fragment>
                        ) : (
                          <Row>
                            <Cell
                              colSpan={tableHead.length + 1}
                              align="center"
                              sx={{ fontWeight: 600 }}
                            >
                              No Data Found
                            </Cell>
                          </Row>
                        )
                      ) : (
                        <Row>
                          <Cell
                            colSpan={tableHead.length + 2}
                            align="center"
                            sx={{ fontWeight: 600 }}
                          >
                            <Box className={classes.loaderWrap}>
                              <CircularProgress />
                            </Box>
                          </Cell>
                        </Row>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </PDFExport>
              {/* ========== Pagination ========== */}
              <Pagination
                currentPage={currentPage}
                pageSize={pageLimit}
                onPageSizeChange={(size) =>
                  getExportVehicles(1, size.target.value)
                }
                tableCount={ExportData?.length}
                totalCount={totalCount}
                onPageChange={(page) => getExportVehicles(page, "")}
              />
            </Fragment>
          ) : (
            <CircleLoading />
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default ExportPaymentList;
